import { render, staticRenderFns } from "./FenXiaoForm.vue?vue&type=template&id=5e1d3611&"
import script from "./FenXiaoForm.vue?vue&type=script&lang=js&"
export * from "./FenXiaoForm.vue?vue&type=script&lang=js&"
import style0 from "./FenXiaoForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports